<template>
  <div class="container-fluid bg-white shadow  fixed-top">
    <div class="row container-xxl px-0 m-auto">
      <div class="col-2 m-auto">
        <a class="navbar-brand py-3" href="#"><img :src="require(`@/assets/${websiteInfo.logo}`)"
                                                   :alt="websiteInfo.name + ' Лого'"></a>
      </div>
      <div class="col-8">
        <nav class="navbar navbar-expand-lg my-3">
          <div class="container-fluid justify-content-center">
            <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNav" aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
              <span class="navbar-toggler-icon"></span>
            </button>
            <div class="collapse navbar-collapse justify-content-center" id="navbarNav" ref="navbar">
              <ul class="navbar-nav">
                <li class="nav-item text-center mx-1 my-2 my-lg-0" v-for="item in navItems">
                  <a class="nav-link" v-if="item.link.match('#')" v-smooth-scroll :href="item.link"
                     :title="item.title" @click="handleMenu(item.title)"
                     :class="{active: isActive === item.title}">{{ item.title }}</a>
                  <a class="nav-link" v-else :href="item.link" :title="item.title">{{ item.title }}</a>
                </li>
              </ul>
            </div>
          </div>
        </nav>
      </div>
      <div class="col-2 d-flex justify-content-end align-items-center pe-0">
        <a :href="facebookPageInfo.url" :title="facebookPageInfo.title" target="_blank"><i
            class="fab fa-facebook fa-2x" aria-hidden="true"></i></a>
      </div>
    </div>
  </div>

</template>

<script>
import {facebookPageInfo, navItems, websiteInfo} from '@/composable/staticData'

export default {
    el: '#navbarNav',
    data() {
        return {
            facebookPageInfo,
            navItems,
            websiteInfo,
            isActive: null
        }
    },
    methods: {
        handleMenu(title) {
            this.isActive = title
            this.$refs.navbar.classList.remove('show')

        }
    }
}
</script>

<style scoped>
li a:hover, li a:focus, li a.active {
    border-bottom: 0.1rem solid #00bdff;
}

#navbarNav a {
    color: #ff8000;
    letter-spacing: 1px;
}
</style>
